import styled from 'styled-components'

import { sv } from '@ucheba/utils/helpers/styles/variables'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${sv.spacing.xlarge};
`

export const NotDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
`

export const NotDescriptionTouch = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  font-size: ${sv.fontSize.h3};
  font-weight: ${sv.fontWeight.bold};
`

export const NotDescriptionText = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;

  font-size: ${sv.fontSize.h5};
  font-weight: ${sv.fontWeight.medium};
`

interface IPinProps {
  color: string
}

export const Pin = styled.div<IPinProps>`
  width: 8px;
  height: 8px;

  border-radius: 50%;
  background: ${(props) => props.color};
`
